import http from "../http-common";

class WorkshopService {
    createWorkshop(data) {
      return http.post("workshop/create", data);
    }
    getWorkshops() {
        return http.get("workshop/list");
    }
    deleteWorkshop(data) {
      return http.delete("workshop/delete", { params: data });
  }
}

export default new WorkshopService();